import { Component } from "@angular/core";
import { XOField } from './xo-field.component';
@Component({
    selector: "xo-field-date",
    templateUrl: "./xo-field-date.component.html"
})
export class XOFieldDate extends XOField {
}
